import React, { Component } from 'react'

class ViewPDFFiles extends Component{
    render(){
        const rawSearch = (window.location.search || '').replace(/^\?/, '');
        let url = rawSearch;
        if (rawSearch.indexOf('url=') === 0) {
            const params = new URLSearchParams(rawSearch);
            url = params.get('url') || '';
        }
        try {
            url = decodeURIComponent(url);
        } catch (e) {
            url = rawSearch;
        }

        // This viewer route is public, so a newly opened popup has no in-memory user role.
        if(!(url && url.length>0 && (url.endsWith(".pdf") || url.indexOf("blob:")===0)))
            url="https://zaps.zolostays.com/error";
        return(
            <embed src={url} width='100%' height='600' type='application/pdf' alt="Your browser don't support this yet">
            </embed>
        )
    }
}
export default ViewPDFFiles;



// WEBPACK FOOTER //
// ./src/components/ViewPDFFiles.js